import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { getSelectedParcel } from '../../common/slice'
import { useAppSelector } from '../../common/store'
import {
  FLOOD_IMPACT_BUTTON_ENABLED,
  FLOOD_IMPACT_URL_ENABLED,
  FLOOD_SUB_PATH,
  LAYER_PLACE_NAMES_PATH,
  PLACENAMES_HELP_LINK_TEXT,
  PLACENAMES_HELP_TITLE,
  PLACENAMES_HELP_URL,
  PLANNING_SUB_PATH,
  LAYER_AERIAL_PHOTOGRAPHY_PATH
} from '../../environment'
import { getPlacenameData } from '../placenames-components/slice'

import './Navbar.css'

const Navbar = () => {
  const location = useLocation()
  const laisKey = useAppSelector(getSelectedParcel)
  const primaryMarker = useAppSelector(getPlacenameData)
  const placeId = primaryMarker ? primaryMarker.placeId : ''

  const renderHelpComponent = () => {
    return (
      <li className="helpItem">
        <a href={PLACENAMES_HELP_URL} title={PLACENAMES_HELP_TITLE} className="a-button">
          <i className="question circle icon"></i>
          {PLACENAMES_HELP_LINK_TEXT}
        </a>
      </li>
    )
  }

  return (
    <div id="landInformationNavbar">
      <nav className="navbar navbar-default navbar-static-top">
        <ul className="nav nav-pills">
          <li className="navli">
            <NavLink to={PLANNING_SUB_PATH + '/' + laisKey + '?zoomto=false'} className="a-button"
                     activeClassName="active">Planning Details</NavLink>
          </li>
          <li className="navli">
            <NavLink to={LAYER_PLACE_NAMES_PATH + '/' + placeId + '?zoomto=false'} className="a-button"
                     activeClassName="active">Place Names</NavLink>
          </li>
          {(FLOOD_IMPACT_URL_ENABLED && FLOOD_IMPACT_BUTTON_ENABLED) &&
              <li className="navli">
                  <NavLink to={FLOOD_SUB_PATH + '/' + laisKey + '?zoomto=false'} className="a-button"
                           activeClassName="active">Flood Impact</NavLink>
              </li>}
            <li className="navli">
                <NavLink to={LAYER_AERIAL_PHOTOGRAPHY_PATH + '/' + laisKey + '?zoomto=false'} className="a-button"
                         activeClassName="active">Aerial Photography</NavLink>
            </li>
          {location.pathname.includes('/placenames') && renderHelpComponent()}
        </ul>
      </nav>
    </div>
  )
}


export default Navbar
